/**
 * @file 闯关首页store
 */
import Vue from 'vue';
import Vuex from 'vuex';
import server from '@/pages/pano-game/service';
import Const from '@/pages/pano-game/constant/Constant';

Vue.use(Vuex);

const state = {
    // 活动数据
    kingRoadData: {},
    // 账户金币数，与主页金币数一样
    myCoin: 0,
    // 活动状态
    activityStatus: 1,
    // 是否中断
    isContinue: Const.continue.no,
    // 中断类型
    continueType: '',
    // 中断关卡
    breakLevel: 0,
    // 可以向上查看数据量（暂未使用，由服务端控制）
    preShowNum: 15,
    // 徽章数量
    medalNum: 0,
    // 免费复活次数
    freeNum: 0,
    // 免费复活次数上限
    freeNumT: 3,
    // 助力复活次数
    assistNum: 0,
    // 助力复活次数上限
    assistNumT: 2,
    // 当前体力值
    staminaNum: 0,
    // 当前体力值上限
    staminaNumT: 10,
    // 关卡数量
    kingRoadNum: 200,
    // 当前解锁关卡
    playMaxLevel: 0,
    // 是否是新用户
    isNewPeople: 0,
    // 当前关卡列表
    levelList: [],
    // 每关消耗金币数
    kingRoadCostCoin: 100
    // // 判断闯关方法
    // checkLevelCoin: null
};

const mutations = {
    setMedalNum(state, data) {
        state.medalNum = data;
    },
    setKingRoadData(state, data) {
        state.kingRoadData = data;
        state.activityStatus = data.activityStatus;
        state.isContinue = data.isContinue;
        state.continueType = data.continuetype;
        state.breakLevel = data.breakLevel;
        state.preShowNum = data.preShowNum || 15;
        state.kingRoadNum = data.kingRoadNum || 200;
        state.myCoin = data.myCoin;
        state.freeNum = data.freeNum;
        state.freeNumT = data.freeNumT;
        state.assistNum = data.assistNum;
        state.assistNumT = data.assistNumT;
        state.staminaNum = data.staminaNum;
        state.staminaNumT = data.staminaNumT;
        state.medalNum = data.medalNum;
        state.playMaxLevel = data.playMaxLevel;
        state.isNewPeople = data.isNewPeople;
        state.levelList = data.consumeRank || [];
        // 闯关到最后时，自动增加空关卡
        if (state.levelList.length === state.kingRoadNum && state.playMaxLevel + 5 > state.kingRoadNum) {
            let i = 0;
            while (state.playMaxLevel + 5 > state.kingRoadNum + i) {
                state.levelList.push({});
                i += 1;
            }
        }
        state.kingRoadCostCoin = data.kingRoadCostCoin || 100;
        // // 验证首页关卡方法
        // data.checkLevelCoin = {
        //     field1: 'x',
        //     field2: 'y',
        //     func: 'var sum=50;sum+=parseInt((x-1)/20+1)*50;sum+=y?100:0;return sum;'
        // };
        // if (data.checkLevelCoin && data.checkLevelCoin.func) {
        //     state.checkLevelCoin = new Function(
        //         data.checkLevelCoin.field1,
        //         data.checkLevelCoin.field2,
        //         data.checkLevelCoin.func
        //     );
        // }
        // todo 调试关卡
        // 初始化用户可视数组(openLevelList)
        // const oll = data.consumeRank || [];
        // const ollLength = oll.length;
        // // 可视数组长度，大于总关卡数时，按照总关卡数显示
        // let vllLength = ollLength + state.preShowNum;
        // vllLength = vllLength > state.kingRoadNum ? state.kingRoadNum : vllLength;
        // while (state.levelList.length < vllLength) {
        //     state.levelList.push({});
        // }
    },
    setStaminaNum(state, data) {
        state.staminaNum = data;
    }
};
const getters = {
};
const actions = {
    getKingRoadMain: ({commit}) => {
        const params = {
            type: Const.gameMode.kingRoad
        };
        return server('getKingRoadMain', params).then(res => {
            if (res && res.errno === 0 && res.data) {
                commit('setKingRoadData', res.data);
                return res.data;
            }
            throw new Error(res.errstr || 'getwrongquestion 数据结构异常');
        }).catch(err => {
            throw err;
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};